import React from 'react';
import type { PromoCodeData } from '../promo-code-field/PromoCodeField';

export type { PromoCodeData };

export type PriceBreakdownRow = {
  label: string;
  amount: string;
  note?: string;
  emphasis?: boolean;
  amountClassName?: string;
};

export type PriceBreakdownData = {
  isLoading?: boolean;
  error?: string | null;
  rows?: PriceBreakdownRow[];
  footnotes?: string[];
  promo?: PromoCodeData | null;
};

function Spinner() {
  return (
    <div className="spinner">
      <div className="spinner-wrapper">
        <div className="rotator">
          <div className="inner-spin" />
          <div className="inner-spin" />
        </div>
      </div>
    </div>
  );
}

function BreakdownRow({ row }: { row: PriceBreakdownRow }) {
  const label = row.emphasis ? <b>{row.label}</b> : row.label;
  const amount = row.emphasis ? <b>{row.amount}</b> : row.amount;

  return (
    <li>
      <div className="list-text-left">
        <p>{label}</p>
        {row.note ? <p className="smaller">{row.note}</p> : null}
      </div>
      <div className="list-text-right">
        <p className={row.amountClassName}>{amount}</p>
      </div>
    </li>
  );
}

export function PriceBreakdown({ data }: { data: PriceBreakdownData }) {
  const rows = data.rows || [];
  const footnotes = data.footnotes || [];
  const showRows = !data.isLoading && !data.error;

  return (
    <div className="component-cart-price-breakdown">
      <div className="content-group">
        {!data.isLoading && data.error ? <p>{data.error}</p> : null}
        {data.isLoading ? <Spinner /> : null}
        {showRows ? (
          <ul className="list">
            {rows.map((row, index) => (
              <BreakdownRow key={`price-row-${index}`} row={row} />
            ))}
          </ul>
        ) : null}
      </div>
      {footnotes.map((footnote, index) => (
        <p key={`footnote-${index}`} className="smaller fee content-group">
          {footnote}
        </p>
      ))}
    </div>
  );
}
